<vwui-header>
  @if (companyType) {
    <h2 a11yPageTitleLevel="1">{{ "PAGE_TIS_VERSIONS.title" | translate : { tisLabelShort: companyType.tisLabelShort, tisLabelLong: companyType.tisLabelLong } }}</h2>
  }
</vwui-header>

<div class="mt-lg">
  <vwui-table [compactable]="false">
    <div slot="table-title">{{ tableConfig.title }}</div>
    <vwui-table-row>
      @for (column of tableConfig.columns; track column) {
        <vwui-table-header>
          {{ column.header}}
        </vwui-table-header>
      }
    </vwui-table-row>

    @if (loadingSpinnerService.isSpinnerVisible()) {
      <vwui-table-row>
        @if (loadingSpinnerService.isSpinnerVisible()) {
          <vwui-spinner></vwui-spinner>
        }
      </vwui-table-row>
    }

    @for (item of allTisDefinitions; track trackTisDefinition($index, item)) {
      <vwui-table-row (click)="onMenuSelect($event)">
        <vwui-table-column>
          {{ item.versionId }}
        </vwui-table-column>
        <vwui-table-column>
          {{ (item.isPublished ? 'PAGE_QUICKSCAN_VERSIONS.published' : 'PAGE_QUICKSCAN_VERSIONS.concept') | translate }}
        </vwui-table-column>
        @if (item.isPublished) {
          <vwui-table-column>
            {{ item.publishedAt | date: ('DATE.long' | translate) }}
          </vwui-table-column>
        }
        @if (!item.isPublished) {
          <vwui-table-column>
            <slot></slot>
          </vwui-table-column>
        }
        <vwui-table-column>
          @if (!item.isPublished) {
            <div class="button-group">
              <vwui-button (click)="openEditVersionModal(item)">
                {{ 'PAGE_QUICKSCAN_VERSIONS.publish' | translate }}
              </vwui-button>
              <vwui-button (click)="editTis(item)">
                {{ 'PAGE_QUICKSCAN_VERSIONS.edit' | translate }}
              </vwui-button>
            </div>
          }
        </vwui-table-column>
      </vwui-table-row>
    }
  </vwui-table>
</div>
